import { render, staticRenderFns } from "./GoodsListPage.vue?vue&type=template&id=0e238a66&"
import script from "./GoodsListPage.vue?vue&type=script&lang=js&"
export * from "./GoodsListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports